import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import { BankAccountReason, BankAccountReasonFilters } from '../../../../app/models/BankAccountReason';
import BankAccountReasonSwitchChange from '../BankAccountReasonSwitchChange';
import BankAccountReasonFilter from './BankAccountReasonFilter';

interface Props {
    bankAccountReasons: BankAccountReason[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    destroy?: (id: number) => void;
    filter: BankAccountReasonFilters;
    setFilter: (filter: BankAccountReasonFilters) => void;
    callbackSuccess: () => void;
    onSearch: () => void;
}

const BankAccountReasonDataTable = ({
    bankAccountReasons,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: BankAccountReason) => <span>{row.id}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: BankAccountReason) => <span>{row.name}</span>
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: BankAccountReason) => (
                <BankAccountReasonSwitchChange
                    checkValue={row.is_active ?? true}
                    bankAccountReasonId={row.id!}
                    callbackSuccess={callbackSuccess}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: BankAccountReason) => (
                <div>
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon="mdi mdi-pencil"
                            colorIcon="text-warning"
                            errorMessage="No se puede editar este registro."
                            title="Editar"
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon="mdi mdi-delete"
                            colorIcon="text-danger"
                            errorMessage="No se puede eliminar este registro."
                            title="Eliminar"
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <BankAccountReasonFilter filter={filter} setFilter={setFilter} onSearch={onSearch} />
                </div>
            </div>
            <DefaultDataTable
                columns={columns}
                data={bankAccountReasons}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default BankAccountReasonDataTable;
